import { API_URL } from "helpers/constant";
import { request } from "./api";

export function getDataFromAccurate(body) {
  return request({
    url: `${API_URL}/accurate-data`,
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function getDatabase() {
  return request({
    url: `${API_URL}/accurate`,
    method: "GET",
  });
}
